// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2h02_","footer":"ReportModalFilter_footer__ji6DU"};